/* Valismo cart drawer.
   State always comes fresh from /cart.js (or the /cart/change.js response,
   which returns the full cart). Rebuilds the item list with DOM APIs — no
   innerHTML with product data. Opens via the floating button; closes on
   overlay click, ×, or Escape. Listens for 'valismo:cart:added' from the
   hero posters and the deck buttons to refresh + pulse the badge. */
(function () {
  'use strict';

  var ROOT_URL =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var wrap = document.querySelector('[data-valismo-cart]');
  if (!wrap) return;

  var fab = wrap.querySelector('[data-cart-toggle]');
  var countEl = wrap.querySelector('[data-cart-count]');
  var headCount = wrap.querySelector('[data-cart-head-count]');
  var itemsEl = wrap.querySelector('[data-cart-items]');
  var footEl = wrap.querySelector('[data-cart-foot]');
  var subtotalEl = wrap.querySelector('[data-cart-subtotal]');
  var savingsEl = wrap.querySelector('[data-cart-savings]');
  var savingsValueEl = wrap.querySelector('[data-cart-savings-value]');
  var closeBtn = wrap.querySelector('[data-cart-close]');
  var overlay = wrap.querySelector('[data-cart-overlay]');

  var currency = 'EUR';

  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  /* ---------- rendering ---------- */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function renderItem(item, line) {
    var row = el('div', 'valismo-cart__item');

    var img = el('img', 'valismo-cart__item-img');
    img.alt = '';
    img.loading = 'lazy';
    if (item.image) {
      img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=128';
    }
    row.appendChild(img);

    var mid = el('div');
    mid.appendChild(el('p', 'valismo-cart__item-title', item.product_title));
    if (item.variant_title && item.variant_title !== 'Default Title') {
      mid.appendChild(el('p', 'valismo-cart__item-variant', item.variant_title));
    }
    var qty = el('div', 'valismo-cart__qty');
    var minus = el('button', null, '−');
    minus.type = 'button';
    minus.setAttribute('aria-label', 'Menge verringern');
    minus.addEventListener('click', function () { changeLine(line, item.quantity - 1); });
    var num = el('span', null, String(item.quantity));
    var plus = el('button', null, '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'Menge erhöhen');
    plus.addEventListener('click', function () { changeLine(line, item.quantity + 1); });
    qty.appendChild(minus);
    qty.appendChild(num);
    qty.appendChild(plus);
    mid.appendChild(qty);
    row.appendChild(mid);

    var side = el('div', 'valismo-cart__item-side');
    /* automatic discounts (e.g. the set offer) lower final_line_price —
       show the original next to it so the saving is actually visible */
    if (item.original_line_price > item.final_line_price) {
      side.appendChild(el('s', 'valismo-cart__item-compare', money(item.original_line_price)));
    }
    side.appendChild(el('span', 'valismo-cart__item-price', money(item.final_line_price)));
    (item.line_level_discount_allocations || []).forEach(function (alloc) {
      if (alloc.discount_application && alloc.discount_application.title) {
        side.appendChild(el('span', 'valismo-cart__item-discount', alloc.discount_application.title));
      }
    });
    var remove = el('button', 'valismo-cart__item-remove', 'Entfernen');
    remove.type = 'button';
    remove.addEventListener('click', function () { changeLine(line, 0); });
    side.appendChild(remove);
    row.appendChild(side);

    return row;
  }

  function render(cart) {
    currency = cart.currency || currency;

    countEl.textContent = cart.item_count;
    countEl.classList.toggle('is-zero', cart.item_count === 0);
    headCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

    itemsEl.textContent = '';
    if (cart.items.length === 0) {
      itemsEl.appendChild(el('p', 'valismo-cart__empty', 'Dein Warenkorb ist leer.'));
      footEl.hidden = true;
      return;
    }

    cart.items.forEach(function (item, index) {
      itemsEl.appendChild(renderItem(item, index + 1));
    });
    subtotalEl.textContent = money(cart.items_subtotal_price);
    if (savingsEl) {
      savingsEl.hidden = !(cart.total_discount > 0);
      savingsValueEl.textContent = '−' + money(cart.total_discount);
    }
    footEl.hidden = false;
  }

  /* ---------- cart API ---------- */

  function refresh() {
    return fetch(ROOT_URL + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    wrap.classList.add('valismo-cart--busy');
    fetch(ROOT_URL + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart change failed');
        return res.json();
      })
      .then(render)
      .catch(refresh)
      .then(function () {
        wrap.classList.remove('valismo-cart--busy');
      });
  }

  /* ---------- open / close ---------- */

  function open() {
    wrap.classList.add('is-open');
    fab.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    refresh();
    closeBtn.focus();
  }

  function close() {
    wrap.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    fab.focus();
  }

  fab.addEventListener('click', function () {
    if (wrap.classList.contains('is-open')) close();
    else open();
  });
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && wrap.classList.contains('is-open')) close();
  });

  /* the product page asks the drawer to open right after adding */
  document.addEventListener('valismo:cart:open', open);

  /* sections dispatch this after a successful AJAX add */
  document.addEventListener('valismo:cart:added', function () {
    refresh().then(function () {
      fab.classList.remove('is-pulsing');
      void fab.offsetWidth; /* restart the animation */
      fab.classList.add('is-pulsing');
    });
  });

  refresh();
})();
